import * as React from 'react';
import { clsx } from 'clsx';
import * as style from './Socials.css';

type ITSocialsProps = {
  theme: 'white' | 'black';
};

export const Socials: React.FC<ITSocialsProps> = ({ theme }) => {
  const iconColor = theme === 'white' ? 'black' : 'white';

  return (
    <div className={style['socials-container']}>
      <a href="https://t.me/cian_realtor" target="_blank" rel="noreferrer">
        <div className={clsx(style['icon'], style[`icon-${theme}`], style[`icon-tg-${iconColor}`])} />
      </a>
      <a href="https://www.youtube.com/channel/UCiT0aVQJwOj2eEvGAckXJjA" target="_blank" rel="noreferrer">
        <div className={clsx(style['icon'], style[`icon-${theme}`], style[`icon-yt-${iconColor}`])} />
      </a>
      <a href="https://vk.com/cian_pro" target="_blank" rel="noreferrer">
        <div className={clsx(style['icon'], style[`icon-${theme}`], style[`icon-vk-${iconColor}`])} />
      </a>
      <a href="https://www.cian.ru/magazine/" target="_blank" rel="noreferrer">
        <div className={clsx(style['icon'], style[`icon-${theme}`], style[`icon-journal-${iconColor}`])}>
          Циан.Журнал
        </div>
      </a>
    </div>
  );
};
